module.exports = __webpack_public_path__ + "static/media/vacation_request.ac9db0b6.svg";